import { createEvent, createEffect, sample, createStore } from "effector";
import { ModelContract, ModuleDescription } from "../module-description";
import { useRouter } from "next/navigation";

type IUseRouter = ReturnType<typeof useRouter> | null;

export const routerInit = createEvent<IUseRouter>();
export const routerPush = createEvent<string>();
export const routerReplace = createEvent<string>();
export const routerBack = createEvent();

export const $router = createStore<IUseRouter>(null);

$router.on(routerInit, (state, payload) => payload);

const pushFx = createEffect(async ({ url, router }: { url: string; router: IUseRouter }) => {
    router?.push(url);
    console.log(`Navigated to: ${url}`);
});

const replaceFx = createEffect(async ({ url, router }: { url: string; router: IUseRouter }) => {
    router?.replace(url);
    console.log(`Navigated replace: ${url}`);
});

const backFx = createEffect(async (router: IUseRouter) => {
    router?.back();
    console.log(`Navigated back`);
});

sample({
    clock: routerPush,
    source: $router,
    filter: (url) => Boolean(url),
    fn(router, url) {
        return {
            url,
            router
        };
    },
    target: pushFx
});

sample({
    clock: routerReplace,
    source: $router,
    filter: (url) => Boolean(url),
    fn(router, url) {
        return {
            url,
            router
        };
    },
    target: replaceFx
});

sample({
    clock: routerBack,
    source: $router,
    fn(router) {
        return router;
    },
    target: backFx
});

const contract = new ModelContract(
    {},
    {
        routerPush,
        routerReplace,
        routerBack
    },
    {},
    {}
);

export type IRouterContract = typeof contract;

export class RouterModule extends ModuleDescription<IRouterContract> {
    getDefaultContract() {
        return contract;
    }
}
